module.exports = __webpack_public_path__ + "img/about.bf46bd20.jpg";